import { useTranslation } from '@exam-room/translations';
import { useDisclosure } from '@shared/hooks';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button, Card, LanguageSwitchMenu, Modal, Page } from '../../components';
import { NetworkAlert } from '../../containers';
import { useConfig } from '../../providers';
import { PATHS } from '../constants';

function Home() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const { language, changeLanguage } = i18n;

  const isSEB = navigator.userAgent.includes('SEB');

  const { safeExamBrowser } = useConfig();

  const [isExitModalOpen, { open, close }] = useDisclosure(false);

  return (
    <>
      <div className='fixed top-0 w-full p-4'>
        <NetworkAlert />
      </div>
      <div className='bg-grey-50 grid size-full place-items-center'>
        <Card className='h-fit w-[800px] px-10 py-20'>
          <div className='absolute top-6 right-6'>
            <LanguageSwitchMenu
              currentLanguage={language.toUpperCase()}
              onSwitchToEnglish={() => {
                changeLanguage('en');
              }}
              onSwitchToThai={() => {
                changeLanguage('th');
              }}
            />
          </div>
          <div className='flex flex-col items-center gap-6'>
            <img src='/logo-white.svg' alt='SET' className='h-20' />
            <div className='flex flex-col items-center gap-3'>
              <h3>{t('home.title')}</h3>
              <p className='text-body1 text-text-secondary font-[400]'>{t('home.subtitle')}</p>
            </div>
            <div className='flex flex-col items-center gap-4'>
              <Button
                className='w-[420px]'
                onClick={() => {
                  navigate({
                    pathname: PATHS.Login,
                    search: searchParams.toString(),
                  });
                }}
              >
                {t('home.button.enter')}
              </Button>
              {isSEB && safeExamBrowser?.quitLink ? (
                <button className='text-info cursor-pointer' onClick={() => open()}>
                  {t('home.button.exit')}
                </button>
              ) : null}
            </div>
          </div>
        </Card>
      </div>
      <Modal open={isExitModalOpen} onClose={close} className='grid max-w-lg gap-6'>
        <h3>{t('home.exitModal.title')}</h3>
        <p className='font-normal'>{t('home.exitModal.description')}</p>
        <div className='flex justify-end gap-5'>
          <Button className='w-[121px] text-black' variant='outlined' onClick={close}>
            {t('home.exitModal.button.cancel')}
          </Button>
          <Button
            className='w-[121px] text-black'
            onClick={() => {
              if (safeExamBrowser?.quitLink) {
                window.location.href = safeExamBrowser.quitLink;
              }
            }}
          >
            {t('home.exitModal.button.confirm')}
          </Button>
        </div>
      </Modal>
    </>
  );
}

const HomeRoute = {
  path: PATHS.Home,
  element: (
    <Page>
      <Home />
    </Page>
  ),
};

export default HomeRoute;
